import { IUniConfig } from "../../uni-base-module"
import { $uniDebug } from "../uni-debug.module"

class IfAdminDirective implements ng.IDirective {
    restrict: "A"
    priority: number = -999

    constructor(private $log: ng.ILogService, private UniConfig: IUniConfig) {
        this.restrict = "A"
    }

    link(scope: ng.IScope, element: JQLite, attrs: ng.IAttributes, ctrls: ng.IController) {
        this.$log.debug("******** Compile if admin", element.html())

        element.addClass("__if__admin__")
    }
}

$uniDebug.directive("ifAdmin", [
    "$log",
    "UniConfig",
    ($log, UniConfig) => new IfAdminDirective($log, UniConfig)
])
